import { useAuth, startLogin } from "@/context/AuthContext";
import { Sparkles, LogOut, LogIn } from "lucide-react";

export default function XpBadge({ compact = false }) {
  const { user, logout } = useAuth();

  if (!user) {
    return (
      <button
        onClick={startLogin}
        data-testid="auth-sign-in"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-900 text-white font-bold text-xs hover:bg-slate-800 transition-colors"
      >
        <LogIn className="w-3.5 h-3.5" />
        {compact ? "Sign in" : "Sign in to earn XP"}
      </button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <div
        data-testid="xp-badge"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-100 text-amber-900 font-bold text-xs border border-amber-200"
      >
        <Sparkles className="w-3.5 h-3.5" />
        <span data-testid="xp-amount">{Math.floor(user.xp || 0)}</span>
        <span className="opacity-70">XP</span>
      </div>
      {!compact && user.picture && (
        <img
          src={user.picture}
          alt={user.name}
          data-testid="user-avatar"
          className="w-7 h-7 rounded-full border border-slate-200"
          referrerPolicy="no-referrer"
        />
      )}
      <button
        onClick={logout}
        data-testid="auth-sign-out"
        aria-label="Sign out"
        title="Sign out"
        className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-600 transition-colors"
      >
        <LogOut className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
